'use client';
import Link from 'next/link';
import { appointmentUrl } from 'src/services/route-utils';

import useMyTestsState from 'src/hooks/useMyTestsState';

export default function FinishAppointmentButton() {
    const { tests } = useMyTestsState();

    return (
        !!tests.length && (
            <div className="drop-shadow-t-lg sticky bottom-0 z-10 bg-white p-4 md:p-8 lg:hidden">
                <Link href={appointmentUrl()} className="btn btn-primary block">
                    Finalizează programarea online
                </Link>
            </div>
        )
    );
}
